import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { InputNumber } from '@plato/ui-legacy/components/ui/input-number';
import type { FocusEventHandler, ReactElement } from 'react';

export type PercentInputProps = {
    disabled?: boolean;
    loading?: boolean;
    name?: string;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    onValueChange: (value: number) => void;
    value: number;
};

export function PercentInput({ onValueChange, ...rest }: PercentInputProps): ReactElement {
    const { defaultCurrency } = useAppConfig();

    return (
        <InputNumber
            {...rest}
            currency={defaultCurrency}
            suffix={` %`}
            onValueChange={({ floatValue }) => {
                onValueChange(floatValue ?? 0);
            }}
            isAllowed={({ floatValue = 0 }) => floatValue >= 0 && floatValue <= 100}
        />
    );
}
